import { createAsyncThunk } from "@reduxjs/toolkit";
import { Organization } from "../../../@types/organization";

import api from "../../../utils/api";

// Busqueda de Organizations
export const findOrganizations = createAsyncThunk(
  "userProfileOrganization/findOrganizations",
  async (arg, { rejectWithValue }) => {
    try {
      // Busca los primeros 1000 organizations y los ordena por nombre
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const response = await fetch(
        `${api.baseURL}organization?select=id,name&populate=false&limit=1000&sort=name%20ASC`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const data = await response.json();
      return data as Organization[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
